import useGetPassiveCycleOptions from 'pages/private/passive-cycle/_hooks/useGetPassiveCycleOptions';

const useGetClOrderOptions = () => {
  const { mappedPassiveCycleOptions } = useGetPassiveCycleOptions('active');

  return { mappedClOrderOptions: mappedPassiveCycleOptions };
};

export default useGetClOrderOptions;
